"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _components = _interopRequireDefault(require("./components"));
var _reactGooglePlacesAutocomplete = _interopRequireDefault(require("react-google-places-autocomplete"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LocationAutocomplete = props => {
  var {
    type,
    onChange,
    inputProps,
    googlePlacesApiKey
  } = props;
  var classes = (0, _styles.default)(props);
  var [optionSelected, setOptionSelected] = _react.default.useState(false);
  var autocompletionRequest = {};
  var filterValue = null;
  if (type === 'city') {
    autocompletionRequest.types = ['(cities)'];
  } else if (['country', 'state'].includes(type)) {
    autocompletionRequest.types = ['(regions)'];
    if (type === 'country') filterValue = 'country';else if (type === 'state') filterValue = 'administrative_area_level_1';
  }
  var WrappedLocationInput = props => {
    var [isFocused, setIsFocused] = _react.default.useState(false);
    return /*#__PURE__*/_react.default.createElement(_components.default, _extends({}, props, {
      inputProps: _objectSpread(_objectSpread({}, inputProps), {}, {
        onFocus: () => {
          setIsFocused(true);
        },
        onBlur: event => {
          props.selectProps.onMenuClose();
          onChange(event.target.value);
          setIsFocused(false);
        }
      }),
      isFocused: isFocused,
      optionSelected: optionSelected,
      clearField: () => {
        setOptionSelected(false);
        onChange('');
      }
    }));
  };
  var Suggestion = _ref => {
    var {
      data,
      selectOption
    } = _ref;
    if (!data.value.types.includes(filterValue)) return null;
    return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      onClick: () => {
        setOptionSelected(true);
        selectOption(data);
        onChange(data.value.structured_formatting.main_text);
      }
    }, /*#__PURE__*/_react.default.createElement(_ListItemText.default, null, data.value.structured_formatting.main_text));
  };
  var SuggestionList = _ref2 => {
    var {
      children
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_Paper.default, {
      elevation: 4,
      className: classes.listContainer
    }, children);
  };
  return /*#__PURE__*/_react.default.createElement(_reactGooglePlacesAutocomplete.default, {
    apiKey: googlePlacesApiKey,
    autocompletionRequest: autocompletionRequest,
    selectProps: {
      placeholder: '',
      closeMenuOnSelect: true,
      styles: {
        control: base => _objectSpread(_objectSpread({}, base), {}, {
          border: 0,
          backgroundColor: 'transparent'
        }),
        valueContainer: base => _objectSpread(_objectSpread({}, base), {}, {
          padding: 0
        })
      },
      components: {
        Input: WrappedLocationInput,
        Option: Suggestion,
        MenuList: SuggestionList,
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
        LoadingIndicator: () => null
      }
    }
  });
};
LocationAutocomplete.defaultProps = {
  inputProps: {
    required: false,
    fullWidth: false,
    error: null,
    helperText: ''
  }
};
var _default = exports.default = LocationAutocomplete;